import {Logout} from "@mui/icons-material";
import {IconButton, Tooltip} from "@mui/material";
import {useSignOut} from "react-firebase-hooks/auth";
import {useHistory} from "react-router-dom";
import {auth} from "../firebase/index.js";


export default function APXLogout() {
	  const [signOut, loading, error] = useSignOut(auth);
	  
	  const history = useHistory();
	  
	  const handleSignOut = () => {
			 signOut().finally(() => history.replace("/"));
	  };
	  return (
				 <>
						<Tooltip title={"Logout"}>
							  <IconButton size={"large"} color={"primary"} onClick={handleSignOut}><Logout/></IconButton>
						</Tooltip>
				 </>
	  );
}